var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRoute } from 'ziggy-js';
import Breadcrumb from '@/Jetstream/Breadcrumb';
import handleUnsavedChanges from "../../Utils/handleUnsavedChanges";
import useForm from "../../Utils/useForm";
import DashboardLayout from "@/Pages/DashboardLayout";
import BranchForm from "@/Pages/Branch/Partials/BranchForm";
import { Ziggy } from "@/ziggy";
export default function Show(_a) {
    var team = _a.team, branch = _a.branch, permissions = _a.permissions;
    console.log('Show...');
    var route = useRoute(Ziggy);
    var form = useForm(__assign({}, branch));
    handleUnsavedChanges(form);
    function submit() {
        form.put(route('team.branch.update', { team: team, branch: branch }), {
            errorBag: 'updateBranch',
            preserveScroll: true,
            onSuccess: function (page) {
                form.setData(page.props.branch);
            }
        });
    }
    return (_jsx(DashboardLayout, __assign({ team: team, branch: branch, title: branch.name + " › Details", pageTitle: branch.name, breadCrumb: _jsx(Breadcrumb, { team: team, branch: null, client: null, current: branch.name }) }, { children: _jsx("div", __assign({ className: "max-w-xl" }, { children: _jsx(BranchForm, { team: team, form: form, submit: submit, close: null, buttonText: "Update" }) })) })));
}
